import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { AppState } from '../../../store';
import { updateMETADATA, updateGoSafeBanners, updateHomePageOffers, updateRTCHomeBanner, updateBusHomeCarousel, saveLoyaltyData } from './../redux/actions';
import { prepareMETAINFOURL, prepareFAQURL, prepareHomeGoSafeBannerURL, prepareOfferURL, rtcHomeBannerUrl, busHomeCarouselUrl } from './../Api';
import megatron, { get } from '@stencil/megatron';
import marked from 'marked';
import { fetchHelper } from '../../../utils/fetchHelper';
import { getCookie } from '../../Review/Utils';
import { useDispatch } from 'react-redux';

export const fetchMETAData = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateMETADATA({ isLoading: true, isError: false, data: {} }));
    const url = prepareMETAINFOURL();

    let data;
    try {
      data = await megatron({
        name: 'Bus META DATA API',
        type: 'GET',
        url,
      });
      if (data && data.success && data.data && data.data.bus_home_page_meta) {
        dispatch(updateMETADATA({ isLoading: false, isError: false, data: data.data.bus_home_page_meta }));
      } else {
        dispatch(updateMETADATA({ isLoading: false, isError: false, data: data }));
      }
    } catch (err) {
      dispatch(updateMETADATA({ isLoading: false, isError: true, data: {} }));
    }

    //   pushga({
    //     event: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventCategory: SrpGAEvents.category,
    //     eventAction: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventLabel: data.buses.length ? SrpGAEvents.actions.bus_SRP_load.labels.success : SrpGAEvents.actions.bus_SRP_load.labels.deadend
    //   });

  }
}

export const fetchGoSafeBanners = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateGoSafeBanners({ isLoading: true, isError: false, data: {} }));
    const url = prepareHomeGoSafeBannerURL();
    try {
      const { data } = await megatron({
        name: 'Bus GO SAFE API',
        type: 'GET',
        url,
      });
      if (data && data.success && data.data && data.data.slots && data.data.slots.bus_home_gosafe_live) {
        dispatch(updateGoSafeBanners({ isLoading: false, isError: false, data: data.data.slots.bus_home_gosafe_live }));
      } else {
        dispatch(updateGoSafeBanners({ isLoading: false, isError: false, data: data }));
      }
    } catch (err) {
      dispatch(updateGoSafeBanners({ isLoading: false, isError: true, data: {} }));
    }

    //   pushga({
    //     event: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventCategory: SrpGAEvents.category,
    //     eventAction: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventLabel: data.buses.length ? SrpGAEvents.actions.bus_SRP_load.labels.success : SrpGAEvents.actions.bus_SRP_load.labels.deadend
    //   });

  }
}

export const fetchHomePageOffers = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateHomePageOffers({ isLoading: true, isError: false, data: [] }));
    const url = prepareOfferURL();

    let data;
    try {

      data = await megatron({
        name: 'BUS Offer API',
        type: 'GET',
        url,
      });
      if (data && data.success && data.data) {
        dispatch(updateHomePageOffers({ isLoading: false, isError: false, data: data.data }));
      } else {
        dispatch(updateHomePageOffers({ isLoading: false, isError: false, data: [] }));
      }
    } catch (err) {
      dispatch(updateHomePageOffers({ isLoading: false, isError: true, data: [] }));
    }

    //   pushga({
    //     event: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventCategory: SrpGAEvents.category,
    //     eventAction: SrpGAEvents.actions.bus_SRP_load.val,
    //     eventLabel: data.buses.length ? SrpGAEvents.actions.bus_SRP_load.labels.success : SrpGAEvents.actions.bus_SRP_load.labels.deadend
    //   });

  }
}

const markedFAQData = (faqData) => {
  var faqInterLinks = [];
  if (faqData && faqData.template && faqData.template.faq) {
    var faqContent = faqData.template.faq.faq_content;
    faqData.template.faq.faq_heading = marked(faqData.template.faq.faq_heading);
    faqInterLinks = (faqData.template.interlinks && faqData.template.interlinks.length) ? faqData.template.interlinks : [];

    faqContent = faqContent.map((item) => {
      item.a = marked(item.a);
      item.q = marked(item.q);
    });
    if (faqInterLinks && faqInterLinks.length) {
      var links = faqInterLinks[0].bus_route_interlinks.links;
      links = links.map((item) => {
        item.heading = marked(item.heading);
        item.subheading = marked(item.subheading);
      });
      faqInterLinks[0].bus_route_interlinks.title = marked(faqInterLinks[0].bus_route_interlinks.title);
      faqInterLinks[0].bus_operator_interlinks.title = marked(faqInterLinks[0].bus_operator_interlinks.title);
      faqInterLinks[0].bus_operator_interlinks.links['bus operators'] = marked(faqInterLinks[0].bus_operator_interlinks.links['bus operators']);
    }
  }
  return faqData;
}

export const fetchFAQData = async () => {
  try {
    const url = prepareFAQURL();
    const data = await fetchHelper({
      name: 'Bus FAQ DATA API',
      type: 'GET',
      url: url,
    });

    if (data && data.api_success && data.data.bus_home_json) {
      const faqData = markedFAQData(data.data.bus_home_json);
      return { isLoading: false, isError: false, data: faqData };
    } else {
      return { isLoading: false, isError: false, data: data };
    }
  } catch (err) {
    return { isLoading: false, isError: true, data: {} };
  }
}

export const fetchRTCHomeBanner = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {

    dispatch(updateRTCHomeBanner({ isLoading: true, isError: false, data: [] }));

    const url = rtcHomeBannerUrl();

    try {
      const data = await megatron({
        name: 'RTC Home Banner Data',
        type: 'GET',
        url,
      });

      if (data && data.success && data.data.bus_rtc_banner_home_page && data.data.bus_rtc_banner_home_page.template) {
        dispatch(updateRTCHomeBanner({ isLoading: false, isError: false, data: data.data.bus_rtc_banner_home_page.template }));
      } else {
        dispatch(updateRTCHomeBanner({ isLoading: false, isError: false, data: [] }));
      }
    } catch (err) {
      dispatch(updateRTCHomeBanner({ isLoading: false, isError: true, data: [] }));
    }
  }
}

export const fetchBusHomeCarousel = (): ThunkAction<void, AppState, {}, AnyAction> => {
  return async (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(updateBusHomeCarousel({ isLoading: true, isError: false, data: [] }));
    const url = busHomeCarouselUrl();
    try {
      const data = await megatron({
        name: 'Bus Home Carousel Data',
        type: 'GET',
        url,
      });
      if (data && data.success && data.data.bus_home_whats_new_carousel && data.data.bus_home_whats_new_carousel.template) {
        dispatch(updateBusHomeCarousel({ isLoading: false, isError: false, data: data.data.bus_home_whats_new_carousel.template }));
      } else {
        dispatch(updateBusHomeCarousel({ isLoading: false, isError: false, data: [] }));
      }
    } catch (err) {
      dispatch(updateBusHomeCarousel({ isLoading: false, isError: true, data: [] }));
    }
  }
}

export const fetchLoyalty = async() => {
  try {
      const auth = getCookie('OAUTH-GOIBIBO')
      const url = 'https://mapi.goibibo.com/lumos/getLoyaltyTierInfo?FullData=true';

      const headers = {
        org: "GI",
        region: "IND",
        auth: auth || "",
        // credentials: "include",
        ["authtoken"]:auth
      };
      const options = {
        headers,
        method: 'GET',
      };
      options['credentials'] =  'include';
      const request = new Request(url);
      const rawResponse = await fetch(request, options);
      const response = await rawResponse.json();
      return response?.currentTier;
     
    } catch (err) {
      console.error("err", err);
    }
  };

